import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentTakeBackComponent } from './component/supplementary-equipment-take-back.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import {  ServiceResponseModule, TransportInfoPanelModule } from '@sdbn/common';

@NgModule({
  declarations: [SupplementaryEquipmentTakeBackComponent],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  exports: [SupplementaryEquipmentTakeBackComponent]
})
export class SupplementaryEquipmentTakeBackModule { }
